// extracted by mini-css-extract-plugin
export default {"container":"damage_container__vIfI8","static":"damage_static__00abr","staticContent":"damage_staticContent__b-ETZ"};